import axios from 'axios';
import { PASSENGERINFO } from '../components/Checkout';
import dayjs from 'dayjs';
import client from '../apollo-client';

import INSERT_AVAILABILITY_NOTIFICATION, {
  AVAILABILITY_NOTIFICATION_STATUS,
  BOATNEW_PRODUCTS_WITH_CITIES
} from '../api/availabilityShortage';
type axiosReturn = {
  data: [
    {
      id: number;
      startTime: string;
      endTime: string;
      allDay: boolean;
      seats: number;
      seatsAvailable: 150;
      prices: PASSENGERINFO[];
    }
  ];
};
interface PRODUCTAVAILABILITY {
  id: number;
  startTime: string;
  endTime: string;
  allDay: boolean;
  seats: number;
  seatsAvailable: number;
  prices: PASSENGERINFO[];
}
type FetchProductInterface = {
  rezdyId: string;
  startDate: any;
  privateTour?: boolean;
  tourName: string;
  cityName: string;
  slug?: string;
};

export const fetchProductAvailabilities = async ({
  rezdyId,
  startDate,
  privateTour,
  tourName,
  cityName,
  slug
}: FetchProductInterface) => {
  const {
    data: { data: productAvailabities }
  } = await axios.post<axiosReturn>(
    `${process.env.NEXT_PUBLIC_AVAILABILITY_URI}/availability`,
    {
      code: rezdyId,
      startDate: dayjs(startDate).startOf('month').format('YYYY-MM-DD'),
      endDate: dayjs(startDate)
        .startOf('month')
        .add(2, 'month')
        .format('YYYY-MM-DD')
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  if (!productAvailabities) {
    const {
      data: { data: productAvailabities }
    } = await axios.get<axiosReturn>(
      `${process.env.NEXT_PUBLIC_AVAILABILITY_URI}/firstAvailability/${rezdyId}`
    );
    return productAvailabities;
  }

  if (privateTour) {
    const data = cleanPrivateAvailability(productAvailabities, slug);
  }

  tourName !== undefined &&
    notifyShortage(productAvailabities, tourName, cityName);
  return productAvailabities;
};
export const updateProductAvailabitoes = async ({
  rezdyId,
  startDate,
  privateTour,
  tourName,
  cityName,
  slug
}: FetchProductInterface) => {
  const {
    data: { data: productAvailabities }
  } = await axios.post<axiosReturn>(
    `${process.env.NEXT_PUBLIC_AVAILABILITY_URI}/availability`,
    {
      code: rezdyId,
      startDate: dayjs(startDate).startOf('month').format('YYYY-MM-DD'),
      endDate: dayjs(startDate)
        .startOf('month')
        .add(1, 'month')
        .format('YYYY-MM-DD')
    },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );

  if (privateTour) {
    return cleanPrivateAvailability(productAvailabities, slug);
  }
  notifyShortage(productAvailabities, tourName, cityName);

  return productAvailabities;
};

interface ProductAvailabities {
  seatsAvailable: number;
  prices: [
    {
      label: string;
      price: number;
    }
  ];
}

const cleanPrivateAvailability = (
  productAvailabities: PRODUCTAVAILABILITY[],
  slug?: string
) => {
  const cleanLessThen7 = productAvailabities.filter(
    availability =>
      availability.seatsAvailable >= 7 || slug === 'private-tour-of-chicago'
  );
  const adjustedPrices = cleanLessThen7.map(availability => {
    const priceOptionsLimit = availability.seatsAvailable;
    return {
      ...availability,
      prices: availability.prices.slice(0, priceOptionsLimit)
    };
  });
  return adjustedPrices;
};
const notifyShortage = async (
  productAvailabilities: PRODUCTAVAILABILITY[],
  tourName: string,
  cityName: string
) => {
  const shortage = productAvailabilities.filter(
    availability => availability.seatsAvailable <= 1
  );
  if (shortage.length > 0) {
    const { data } = await client.query({
      query: BOATNEW_PRODUCTS_WITH_CITIES
    });
    const managersEmails = Array.from(
      new Set(
        data.boatnew_products
          .flatMap((product: any) => product?.cities_products)
          .filter(
            (cityProduct: any) =>
              cityProduct?.city?.name?.trim().toLowerCase() ===
              cityName?.trim().toLowerCase()
          )
          .map((cityProduct: any) => cityProduct.city.ops_manager?.email)
          .filter((email: any) => email)
      )
    );
    for (const shortageItem of shortage) {
      const { id, seatsAvailable, seats } = shortageItem;

      try {
        const alreadyNotified = await client.query({
          query: AVAILABILITY_NOTIFICATION_STATUS,
          variables: { id }
        });
        if (alreadyNotified.data.boatnew_availability_shortage.length === 0) {
          await client.mutate({
            mutation: INSERT_AVAILABILITY_NOTIFICATION,
            variables: {
              id,
              seats_remaining: seatsAvailable,
              total_seats: seats,
              slot: `${dayjs(shortageItem.startTime).format('hh:mm A')}-${dayjs(
                shortageItem.endTime
              ).format('hh:mm A')} `,
              date: dayjs(shortageItem.startTime).format('YYYY-MM-DD'),
              tour: tourName,
              managerEmail: managersEmails[0],
              city: cityName
            }
          });
        }
      } catch (error) {
        console.error('Error inserting notification:', error);
      }
    }
  }
};
